import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { includes, isEmpty } from 'lodash';

import TextNavbar from './TextNavbar';
import PublicThematicTable from '../../pages/PublicThematicTable';

import { ChildContainer } from './styles';

const { defaultTableSource } = Meteor.settings.public;

const TableIframe = ({
  tableSource,
  tableTitle,
  tableTitleColor,
  tableTitleSize,
  tableTitleTextSize
}) => {
  const absoluteUrl = Meteor.absoluteUrl('shared/data/');
  if (includes(tableSource, absoluteUrl)) {
    const tablePublicId = tableSource.split('/').pop();
    const matchProp = { params: { public_layer_data_id: tablePublicId } };
    return (
      <>
        {!isEmpty(tableTitle) && (
          <TextNavbar
            navbarColor={tableTitleColor}
            navbarHeight={tableTitleSize}
            navbarText={tableTitle}
            navbarTextSize={tableTitleTextSize}
          />
        )}
        <ChildContainer heightToRemove={isEmpty(tableTitle) ? '0px' : tableTitleSize}>
          <PublicThematicTable match={matchProp} isAtlas />
        </ChildContainer>
      </>
    );
  }
  return (
    <>
      {!isEmpty(tableTitle) && (
        <TextNavbar
          navbarColor={tableTitleColor}
          navbarHeight={tableTitleSize}
          navbarText={tableTitle}
          navbarTextSize={tableTitleTextSize}
        />
      )}
      <ChildContainer heightToRemove={isEmpty(tableTitle) ? '0px' : tableTitleSize}>
        <iframe src={tableSource} width="100%" height="100%" align="center" title="TableIframe" />
      </ChildContainer>
    </>
  );
};

TableIframe.defaultProps = {
  tableSource: defaultTableSource,
  tableTitle: '',
  tableTitleColor: 'black',
  tableTitleSize: '15px',
  tableTitleTextSize: '15px'
};

TableIframe.propTypes = {
  tableSource: PropTypes.string,
  tableTitle: PropTypes.string,
  tableTitleColor: PropTypes.string,
  tableTitleSize: PropTypes.string,
  tableTitleTextSize: PropTypes.string
};

export default TableIframe;
